import slick from "slick-carousel";

export function idxFunc() {
  const indexPage = $("#indexTop").length;
  let resizecheck = $("#responsibleCheck").width();

  $(window).on("resize", function () {
    resizecheck = $("#responsibleCheck").width();
  });

  if (!indexPage) return;

  const $sliderIntro = $(".slideAreaIntro");

  if ($sliderIntro.length && !$sliderIntro.hasClass("slick-initialized")) {
    $sliderIntro.slick({
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 400,
      slidesToShow: 2,
      arrows: true,
      dots: true,
      fade: false,
      infinite: true,
      pauseOnTouchMove: false,
      pauseOnHover: false,
      centerMode: true,
      centerPadding: "0px",
      variableWidth: true,
      nextArrow: '<img src="/s/garrack/feature/cosmicprincesskaguya/images/fv/fv-intro-next-arrow.svg" class="slide-arrow next-arrow">',
      prevArrow: '<img src="/s/garrack/feature/cosmicprincesskaguya/images/fv/fv-intro-prev-arrow.svg" class="slide-arrow prev-arrow">',
    });

    // dotsにclass付与
    $sliderIntro.find(".slick-dots li").each(function (index) {
      $(this).addClass(`dot-${index + 1}`);
    });
  }

  const slideStart = function () {
    $(".slideArea").each(function () {
      const $_t = $(this);

      if (resizecheck <= 1) {
        if ($_t.hasClass("slick-initialized")) {
          $_t.slick("unslick");
          $_t.off("beforeChange.mySlide afterChange.mySlide");
        }
        return;
      }

      if (!$_t.hasClass("slick-initialized")) {
        $_t.slick({
          autoplay: true,
          autoplaySpeed: 5000,
          speed: 400,
          slidesToShow: 1,
          arrows: true,
          dots: true,
          fade: false,
          infinite: true,
          pauseOnTouchMove: false,
          pauseOnHover: false,
          centerMode: true,
          centerPadding: "0px",
          variableWidth: true,
          nextArrow: '<img src="/s/garrack/feature/cosmicprincesskaguya/images/fv/fv-intro-next-arrow.svg" class="slide-arrow next-arrow">',
          prevArrow: '<img src="/s/garrack/feature/cosmicprincesskaguya/images/fv/fv-intro-prev-arrow.svg" class="slide-arrow prev-arrow">',
        });
      }

      $_t.find(".slick-dots li").each(function (index) {
        $(this).addClass("dot-" + (index + 1));
      });
    });
  };

  // slideArea2

  slideStart();

  let setTimer = null;
  $(window).on("resize", function () {
    clearTimeout(setTimer);
    setTimer = setTimeout(slideStart, 200);
  });
}

export function idxFunc2() {
  const indexPage = $("#indexTop").length;
  let resizecheck = $("#responsibleCheck").width();

  $(window).on("resize", function () {
    resizecheck = $("#responsibleCheck").width();
  });

  if (!indexPage) return;

  const slideStart = function () {
    $(".detailWatchItemDialInfo2SlideArea").each(function () {
      const $slider = $(this);

      if (resizecheck <= 1) {
        if ($slider.hasClass("slick-initialized")) {
          $slider.slick("unslick");
        }
        return;
      }

      if (!$slider.hasClass("slick-initialized")) {
        $slider.slick({
          autoplay: true,
          autoplaySpeed: 5000,
          speed: 400,
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
          dots: true,
          fade: false,
          infinite: true,
          pauseOnTouchMove: false,
          pauseOnHover: false,
          centerMode: false,
          centerPadding: "0px",
          variableWidth: true,
          nextArrow: '<img src="/s/garrack/feature/cosmicprincesskaguya/images/fv/fv-intro-next-arrow.svg" class="slide-arrow next-arrow">',
          prevArrow: '<img src="/s/garrack/feature/cosmicprincesskaguya/images/fv/fv-intro-prev-arrow.svg" class="slide-arrow prev-arrow">',
        });
      }

      $slider.find(".slick-dots li").each(function (index) {
        $(this).addClass(`dot-${index + 1}`);
      });
    });
  };

  slideStart();

  let setTimer = null;
  $(window).on("resize", function () {
    clearTimeout(setTimer);
    setTimer = setTimeout(slideStart, 200);
  });
}
